export const updateVariationEan = () => {
  const updateEan = (variation) => {
      const eanElement = document.querySelector('#product-ean');
      if (!eanElement) return;

      if (variation && variation.global_unique_id) {
          eanElement.textContent = variation.global_unique_id;
      } else {
          eanElement.textContent = 'Code EAN manquant';
      }
  };

  jQuery(document).ready(function($) {
    $('form.variations_form').on('found_variation', function (event, variation) {
      updateEan(variation);
    });
  });
};
